/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Services;
    (function (Services) {
        var HttpService = /** @class */ (function () {
            function HttpService($http, $q, authenticationService, localStorageService, locationService, appSettings) {
                this.$http = $http;
                this.$q = $q;
                this.authenticationService = authenticationService;
                this.localStorageService = localStorageService;
                this.locationService = locationService;
                this.appSettings = appSettings;
                this.authData = this.authenticationService.authorizationData;
                this.oneMinuteInMilliseconds = 60 * 1000;
                // To allow us to cancel all pending http requests
                this.pendingRequests = [];
                this.shouldTimeStampUrl = true;
                this.timeStampKey = 'vTaSDHWefh';
            }
            HttpService.prototype.attemptLocalStorageFirst = function (localStorageKey, action, bustCache) {
                var hasLocalStorageKey = !ap.Utilities.isNullOrWhitespace(localStorageKey);
                if (ap.Utilities.isTrueValue(bustCache) && hasLocalStorageKey) {
                    this.localStorageService.deleteItem(localStorageKey);
                }
                if (!hasLocalStorageKey) {
                    return action();
                }
                var service = this;
                return this.localStorageService.getItem(localStorageKey)
                    .then(function (localItem) {
                    if (!ap.Utilities.isNullOrUndefined(localItem)) {
                        return service.resolveDeferred(localItem);
                    }
                    return action().then(function (response) {
                        service.localStorageService.setItem(localStorageKey, response);
                        return response;
                    });
                });
            };
            /**
             * Makes a POST to the url with the specified data object
             * @param url - The url or endpoint
             * @param data - The data to be transmitted to the server
             * @param isFormData - A value indicating whether the data object is a form data object
             * @param localStorageKey - The local storage key should the data be cached/stored locally until the user logs out of the system.
             * @param bustCache - A value indicating that even if the data is already present that the request to the server should be completed and the returned data replace the currently stored object.
             */
            HttpService.prototype.create = function (url, data, isFormData, localStorageKey, bustCache) {
                var _this = this;
                var action = function () { return _this.makeHttpRequest(HttpRequestType.POST, ap.Utilities.isTrueValue(isFormData), url, data); };
                return this.attemptLocalStorageFirst(localStorageKey, action, bustCache);
            };
            /**
             * Makes a DELETE request to the server
             * @param url - The url or endpoint
             * @param localStorageKey - The local storage key should the data be cached/stored locally until the user logs out of the system.
             */
            HttpService.prototype.delete = function (url, localStorageKey) {
                if (!ap.Utilities.isNullOrWhitespace(localStorageKey)) {
                    this.localStorageService.deleteItem(localStorageKey);
                }
                return this.makeHttpRequest(HttpRequestType.DELETE, false, url);
            };
            /**
             * Sets a value indicating whether the urls should be time stamped to prevent caching between client and server.
             * @param value - True if the url should contain the current timestamp, false will call the specified url only.
             */
            HttpService.prototype.enableTimeStampedUrl = function (value) {
                this.shouldTimeStampUrl = ap.Utilities.isTrueValue(value);
            };
            /**
             * Makes a GET request to the server if NO data is present or a POST if data is present.
             * @param url - The url or endpoint
             * @param data - The data used for a get but to large for a GET url string
             * @param localStorageKey - The local storage key should the data be cached/stored locally until the user logs out of the system.
             * @param bustCache - A value indicating that even if the data is already present that the request to the server should be completed and the returned data replace the currently stored object.
             */
            HttpService.prototype.get = function (url, data, localStorageKey, bustCache) {
                var _this = this;
                var action = function () { return _this.makeHttpRequest(ap.Utilities.isNullOrUndefined(data) ? HttpRequestType.GET : HttpRequestType.POST, false, url, data); };
                return this.attemptLocalStorageFirst(localStorageKey, action, bustCache);
            };
            HttpService.prototype.getRenewPromise = function () {
                return this.$q.when(this.authRefreshPromise);
            };
            HttpService.prototype.getRequestConfig = function (type, url, data, includeContentTypeHeader) {
                var _a;
                var config = {
                    data: data,
                    headers: (_a = {
                            Authorization: "Bearer " + this.authData.AccessToken
                        },
                        //['X-AppCacheKey']: this.appSettings.applicationCacheKey,
                        _a['X-LangId'] = this.authData.PreferredLanguageId ? this.authData.PreferredLanguageId.toString() : '1',
                        _a['X-OrgUnitCacheKey'] = this.locationService.getOrganizationCacheKey(undefined, true, true),
                        _a),
                    method: "" + HttpRequestType[type],
                    originalUrl: url,
                    url: this.timeStampUrl(url),
                    type: type
                };
                if (ap.Utilities.isTrueValue(includeContentTypeHeader)) {
                    config.headers['Content-Type'] = undefined;
                    config.transformRequest = angular.identity;
                }
                return config;
            };
            HttpService.prototype.getPendingRequest = function (url, type, config) {
                var _this = this;
                if (ap.Utilities.isNullOrEmptyCollection(this.pendingRequests)) {
                    return null;
                }
                config = config || this.pendingRequests.find(function (x) { return x.config.originalUrl === url && x.config.type === type && x.organizationCacheKey === _this.locationService.getOrganizationCacheKey(); });
                if (!ap.Utilities.isNullOrUndefined(config)) {
                    config.index = this.pendingRequests.indexOf(config);
                    if (config.index > -1) {
                        return config;
                    }
                }
                return null;
            };
            HttpService.prototype.handleError = function (error, ctrl) {
                ctrl = ctrl || this;
                if (error.status === 401) {
                    console.error('401 error');
                    ctrl.authenticationService.logout();
                    return null;
                }
                //ctrl.crudMessageService<DataType>.notifyError(error);
                //notifyError<T>(error: IAngularError<T>): void {
                //	error.
                //}
                console.error('Unexpected server error', error.statusText);
                return null;
            };
            HttpService.prototype.makeHttpRequest = function (type, isFormData, url, data) {
                var _this = this;
                return this.getRenewPromise().then(function () {
                    var pendingRequest;
                    // This would check if the request being made is already running and simply return the promise rather than queueing a new request to the same Url.
                    if (type === HttpRequestType.GET && !ap.Utilities.isNullOrUndefined(pendingRequest = _this.getPendingRequest(url, type)) && !ap.Utilities.isNullOrUndefined(pendingRequest.promise)) {
                        return pendingRequest.promise;
                    }
                    pendingRequest = {
                        config: _this.getRequestConfig(type, url, data, isFormData),
                        canceller: _this.$q.defer(),
                        organizationCacheKey: _this.locationService.getOrganizationCacheKey()
                    };
                    _this.pendingRequests.push(pendingRequest);
                    var thenFunc = function (response) {
                        // We may need to address the null return response. I think that this is the reason that we see errors on fast page changing
                        // Meaning that if you open the route-sheet then open a repair order and before the page loads you switch from estimate to
                        // inspection then to parts and then back to estimate or inspection you will see JavaScript errors thrown in the console.
                        // They do nothing because the page that was loading has been dumped from memory and the new page is processing and continues
                        // to process.
                        return (response || { data: null }).data;
                    };
                    var finallyFunc = function () {
                        var request = _this.getPendingRequest(url, type, pendingRequest);
                        if (!ap.Utilities.isNullOrUndefined(request)) {
                            _this.pendingRequests.splice(request.index, 1);
                        }
                    };
                    pendingRequest.promise = _this.$http(pendingRequest.config)
                        .then(thenFunc, function (error) { return _this.handleError(error, _this); })
                        .finally(finallyFunc);
                    return pendingRequest.promise;
                });
            };
            /**
             * This should ONLY be used by the ssoApiService to renew the authentication data object.
             * @param url - The url or endpoint to get the authentication data
             * @param data - Renewal token data to transmit to the server
             */
            HttpService.prototype.renew = function (url, data) {
                var action = this.create(url, data);
                // You will be done renewing before the token is expired therefore allow others to continue without delay
                if (!this.authData.isStale(this.oneMinuteInMilliseconds)) {
                    return action;
                }
                // The token is expired or will before the other requests can be completed so delay the request until this renewal has completed
                return this.authRefreshPromise = action;
            };
            /**
             * Ensures that the object specified is wrapped in an ng.IPromise
             * @param object - The object to be returned in the promise
             */
            HttpService.prototype.resolveDeferred = function (object) {
                return this.$q.when(object);
            };
            /**
             * Using the PUT method sends the data to the $http service
             * @param url - The url or endpoint
             * @param data - The data to be PUT on the server
             * @param isFormData - A value indicating whether the data is a form data object
             */
            HttpService.prototype.update = function (url, data, isFormData) {
                return this.makeHttpRequest(HttpRequestType.PUT, ap.Utilities.isTrueValue(isFormData), url, data);
            };
            HttpService.prototype.timeStampUrl = function (url) {
                if (!this.shouldTimeStampUrl) {
                    return url;
                }
                var hasQueryString = url.search('\\?') !== -1;
                var queryParam = hasQueryString ? '&' : '?';
                var timeStamp = new Date().getTime();
                return "" + url + queryParam + this.timeStampKey + "=" + timeStamp;
            };
            HttpService.$inject = [
                '$http',
                '$q',
                'authenticationService',
                'localStorageService',
                'locationService',
                'appSettings'
            ];
            return HttpService;
        }());
        Services.HttpService = HttpService;
        angular.module('app.Services')
            .service('httpService', HttpService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
